import { render, staticRenderFns } from "./SkeletonLoaderChart.vue?vue&type=template&id=59b86283&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b86283",
  null
  
)

export default component.exports